import React, { useEffect, useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    faCheckCircle,
    faTimesCircle,
    faSpinner,
    faArrowLeft,
    faEnvelopeOpenText,
    faShieldAlt,
    faUserCheck
} from '@fortawesome/free-solid-svg-icons';
import request from '../../../../request';
import './TurneroAuth.css'; // Reuse login styles

const VerifyEmail = ({ ipserv }) => {
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const [status, setStatus] = useState('verifying'); // verifying, success, error
    const [message, setMessage] = useState('');

    useEffect(() => {
        const token = searchParams.get('token');
        if (!token) {
            setStatus('error');
            setMessage('Token de verificación no encontrado en el enlace.');
            return;
        }

        const API_BASE = process.env.REACT_APP_API_URL || 'http://localhost:5000/';
        request.Get(API_BASE + 'turnero/verify-email', { token }, r => {
            if (r.success) {
                setTimeout(() => {
                    setStatus('success');
                    setMessage('¡Tu cuenta ha sido verificada con éxito! Ya tienes acceso completo a la plataforma.');
                }, 1500); // Artificial delay for premium feel
            } else {
                setTimeout(() => {
                    setStatus('error');
                    setMessage(r.msg || 'El enlace de verificación ha expirado o es inválido.');
                }, 1000);
            }
        });
    }, [searchParams]);

    return (

        <div className="auth-page-container align-items-center justify-content-center">
            {/* Mesh Background Blobs (Same as TurneroAuth) */}
            <div className="auth-blobs">
                <motion.div
                    className="auth-blob"
                    style={{ width: '450px', height: '450px', background: '#4f46e5', left: '15%', top: '20%' }}
                    animate={{ scale: [1, 1.2, 1], x: [0, 40, 0], y: [0, 20, 0] }}
                    transition={{ duration: 15, repeat: Infinity, ease: "easeInOut" }}
                />
                <motion.div
                    className="auth-blob"
                    style={{ width: '380px', height: '380px', background: '#db2777', right: '15%', bottom: '20%' }}
                    animate={{ scale: [1, 1.3, 1], x: [0, -30, 0], y: [0, 50, 0] }}
                    transition={{ duration: 18, repeat: Infinity, ease: "easeInOut", delay: 2 }}
                />
            </div>

            <motion.div
                initial={{ opacity: 0, scale: 0.9, y: 20 }}
                animate={{ opacity: 1, scale: 1, y: 0 }}
                transition={{ duration: 0.5, ease: [0.23, 1, 0.32, 1] }}
                className="auth-card p-0 overflow-hidden"
                style={{ maxWidth: '500px', zIndex: 10 }}
            >
                <div className="p-5 text-center" style={{ background: 'linear-gradient(135deg, rgba(79, 70, 229, 0.1) 0%, rgba(219, 39, 119, 0.05) 100%)', borderBottom: '1px solid rgba(255,255,255,0.05)' }}>
                    <h1 className="auth-title m-0" style={{ fontSize: '3rem' }}>TuFila</h1>
                    <p className="text-white text-uppercase small letter-spacing-2 font-weight-bold mb-0" style={{ opacity: 0.5, marginTop: '5px' }}>Seguridad de Cuenta</p>
                </div>

                <div className="p-5 text-center">
                    <AnimatePresence mode='wait'>
                        {status === 'verifying' && (
                            <motion.div
                                key="verifying"
                                initial={{ opacity: 0 }}
                                animate={{ opacity: 1 }}
                                exit={{ opacity: 0 }}
                                className="py-4"
                            >
                                <div className="loading-container mb-4">
                                    <FontAwesomeIcon icon={faShieldAlt} size="4x" className="text-primary opacity-20" />
                                    <div className="spinner-overlay">
                                        <FontAwesomeIcon icon={faSpinner} spin size="2x" className="text-primary" />
                                    </div>
                                </div>
                                <h4 className="font-weight-bold text-white">Validando Credenciales</h4>
                                <p className="text-white-50">Estamos verificando tu token de seguridad...</p>
                            </motion.div>
                        )}

                        {status === 'success' && (
                            <motion.div
                                key="success"
                                initial={{ opacity: 0, y: 20 }}
                                animate={{ opacity: 1, y: 0 }}
                                className="py-4"
                            >
                                <div className="success-icon-premium mb-4 mx-auto">
                                    <div className="icon-pulse"></div>
                                    <FontAwesomeIcon icon={faUserCheck} />
                                </div>
                                <h3 className="font-weight-bold text-white mb-3">¡Verificación Exitosa!</h3>
                                <p className="text-white-50 mb-5 px-4">{message}</p>
                                <button
                                    className="auth-btn-primary w-100"
                                    onClick={() => navigate('/Turnero/Login')}
                                >
                                    <span>INGRESAR A LA PLATAFORMA</span>
                                    <FontAwesomeIcon icon={faArrowLeft} className="ml-2" style={{ transform: 'rotate(180deg)' }} />
                                </button>
                            </motion.div>
                        )}

                        {status === 'error' && (
                            <motion.div
                                key="error"
                                initial={{ opacity: 0, y: 20 }}
                                animate={{ opacity: 1, y: 0 }}
                                className="py-4"
                            >
                                <div className="error-icon-premium mb-4 mx-auto">
                                    <FontAwesomeIcon icon={faTimesCircle} />
                                </div>
                                <h3 className="font-weight-bold text-white mb-3">Error de Verificación</h3>
                                <p className="text-white-50 mb-5 px-4">{message}</p>
                                <button
                                    className="auth-btn-primary w-100"
                                    style={{ background: 'transparent', border: '1px solid rgba(255,255,255,0.2)' }}
                                    onClick={() => navigate('/Turnero/Login')}
                                >
                                    <FontAwesomeIcon icon={faArrowLeft} className="mr-2" /> VOLVER AL INICIO
                                </button>
                            </motion.div>
                        )}
                    </AnimatePresence>
                </div>
            </motion.div>

            <style>{`
                .letter-spacing-2 { letter-spacing: 2px; }
                .loading-container {
                    position: relative;
                    display: inline-block;
                }
                .spinner-overlay {
                    position: absolute;
                    top: 50%;
                    left: 50%;
                    transform: translate(-50%, -50%);
                }
                .success-icon-premium {
                    width: 100px;
                    height: 100px;
                    background: linear-gradient(135deg, #10b981 0%, #059669 100%);
                    border-radius: 50%;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    font-size: 3rem;
                    color: white;
                    position: relative;
                    box-shadow: 0 10px 30px rgba(16, 185, 129, 0.4);
                }
                .icon-pulse {
                    position: absolute;
                    width: 100%;
                    height: 100%;
                    border-radius: 50%;
                    background: #10b981;
                    opacity: 0.5;
                    animation: pulse-out 2s infinite;
                }
                @keyframes pulse-out {
                    0% { transform: scale(1); opacity: 0.5; }
                    100% { transform: scale(1.5); opacity: 0; }
                }
                .error-icon-premium {
                    width: 100px;
                    height: 100px;
                    background: linear-gradient(135deg, #ef4444 0%, #dc2626 100%);
                    border-radius: 50%;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    font-size: 3rem;
                    color: white;
                    box-shadow: 0 10px 30px rgba(239, 68, 68, 0.4);
                }
            `}</style>
        </div>
    );
};

export default VerifyEmail;
